module.exports = __webpack_public_path__ + "media/flags/mm-4c3ba8ba.svg";